import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronLeft, ChevronRight, Loader } from 'react-feather';
import {
  Input,
  Row,
  Col,
  Button,
  UncontrolledAccordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Container,
  Card,
  CardBody,
  CardHeader,
  Collapse,
} from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import TypeCard from '../Comman/TypeCard';
import dots from '../../../../../../../assets/images/dots.svg';
import mapVendor from '../../../../../../../assets/images/map-vendor.svg';
import { SAVE_DRAFT_CONFIGURATION, UPDATE_DRAFT_CONFIGURATION } from '../../../../../../../store/actions';
import { useDispatch } from 'react-redux';
import cogoToast from 'cogo-toast';
import airplane from '../../../../../../../assets/images/airplane.svg';

const AssignZonesToClient = ({ state, setState, setFormCount, isDraftConfiguration, configuration }) => {
  const dispatch = useDispatch();

  console.log('State', state);

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [zoneTypeDropdownOpen, setZoneTypeDropdownOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState<any>({});
  const [isCollapse, setIsCollapse] = useState(false);

  useEffect(() => {
    if (state?.client) {
      setSelectedClient(state.client);
    }
  }, []);

  const filteredAirports = state?.clientPricing?.airports.filter(airport => airport.name.toLowerCase().includes(searchText.toLowerCase()));

  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const validateAllZonesMapped = () => {
    // Flatten all available zones
    const allZones = state?.clientPricing?.airports?.flatMap(airport => airport.zones || []) || [];

    // Zones currently assigned to the client
    const assignedZones = selectedClient?.zones || [];

    // Compare by zone id + airport id
    const isEveryZoneMapped = allZones.every(zone => assignedZones.some(z => z.id === zone.id && z.airport.id === zone.airport.id));

    if (!isEveryZoneMapped) {
      cogoToast.error('Please assign all zones to the client before proceeding.');
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validateAllZonesMapped()) return;
    setFormCount(prev => prev + 1);
  };

  const saveAsDraftHandler = () => {
    if (!validateAllZonesMapped()) return;
    dispatch({
      type: SAVE_DRAFT_CONFIGURATION,
      payload: {
        data: {
          configuration_data: {
            client: state?.client,
            project: state?.project,
            benefit: state?.benefit,
            benefitGroup: state?.benefitGroup,
            vendorPricing: state?.vendorPricing,
            clientPricing: state?.clientPricing,
            page: 13,
          },
          configuration_type: 'program_onboarding',
          status: 'DRAFT',
        },
      },
    });
  };

  const updateAsDraftHandler = () => {
    if (!validateAllZonesMapped()) return;
    dispatch({
      type: UPDATE_DRAFT_CONFIGURATION,
      payload: {
        data: {
          configuration_data: {
            client: state?.client,
            project: state?.project,
            benefit: state?.benefit,
            benefitGroup: state?.benefitGroup,
            vendorPricing: state?.vendorPricing,
            clientPricing: state?.clientPricing,
            page: 13,
          },
          configuration_type: 'program_onboarding',
          status: 'DRAFT',
          id: configuration?.id,
        },
      },
    });
  };

  const handleZoneToggle = zone => {
    const existingZones = selectedClient?.zones || [];
    const zoneExists = existingZones.some(z => z?.id === zone?.id && z?.airport?.id === zone?.airport?.id);

    let updatedZones = zoneExists
      ? existingZones.filter(z => !(z?.id === zone?.id && z?.airport?.id === zone?.airport?.id))
      : [...existingZones, zone];

    updatedZones = updatedZones?.map(updatedZone => {
      return {
        id: updatedZone?.id,
        name: updatedZone?.name,
        airport: updatedZone?.airport,
      };
    });

    const updatedClient = {
      ...selectedClient,
      zones: updatedZones,
    };

    setSelectedClient(updatedClient);

    setIsCollapse(true);

    setState(prev => ({
      ...prev,
      client: updatedClient,
    }));
  };

  const handleZoneRemove = zoneId => {
    const updatedZones = (selectedClient?.zones || []).filter(z => z?.id !== zoneId);

    const updatedClient = {
      ...selectedClient,
      zones: updatedZones,
    };

    setSelectedClient(updatedClient);

    setState(prev => ({
      ...prev,
      client: updatedClient,
    }));
  };

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <BreadcrumbTrail
            title={`Airport Configuration Setup`}
            navigationby={breadcrumNavigationHandler}
            navigation={['Management', 'Program', 'Onboarding', 'Map Zones to Client']}
          />
        </div>

        <Card>
          <CardHeader className="d-flex justify-content-between p-0">
            <h5 className="m-0 fw-semibold px-3">Assign Zones to the Client</h5>
            <TypeCard typeName={'Client'} name={state?.client?.name} />
          </CardHeader>
          <CardBody>
            <Row className="mb-3">
              <Col md="7">
                <div className="position-relative border border-radius-5 p-3">
                  <Row className="align-items-center mb-3">
                    <Col md={6}>
                      <h5>Available Zones</h5>
                      <p className="text-muted">Click to add/remove zones for the client</p>
                    </Col>
                    {/* <Col md={3}>
                      <Dropdown isOpen={airportDropdownOpen} toggle={toggleAirportDropdown}>
                        <DropdownToggle caret color="light" className="w-100">
                          All Airports
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem>All Airports</DropdownItem>
                          <DropdownItem>DXB</DropdownItem>
                          <DropdownItem>Abu Dhabi</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </Col> */}
                    {/* <Col md={3}>
                      <Dropdown isOpen={zoneTypeDropdownOpen} toggle={toggleZoneTypeDropdown}>
                        <DropdownToggle caret color="light" className="w-100">
                          Zone Type
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem>All</DropdownItem>
                          <DropdownItem>Servicable</DropdownItem>
                          <DropdownItem>Non-servicable</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </Col> */}
                  </Row>

                  <Row className="align-items-center mb-3">
                    <Col md={12}>
                      <Input type="text" placeholder="Search Airport" value={searchText} onChange={e => setSearchText(e.target.value)} />
                    </Col>
                  </Row>

                  <div className="airport-zones-list" style={{ maxHeight: '212px', overflowY: 'auto' }}>
                    <UncontrolledAccordion stayOpen>
                      {filteredAirports.map(airport => (
                        <AccordionItem key={airport.id} className="mb-2">
                          <AccordionHeader targetId={airport.id}>
                            <div className="w-100 d-flex justify-content-between align-items-center">
                              {/* Left Section */}
                              <div className="d-flex gap-2 align-items-center">
                                <img src={airplane} alt="" style={{ width: '20px' }} />
                                <div>
                                  <p className="m-0 fw-semibold">{airport.name}</p>
                                  <small className="text-muted">{airport?.zones?.length} Zones</small>
                                </div>
                              </div>

                              {/* Right Section */}
                              <div className="d-flex align-items-center gap-2 me-3 cursor-pointer">
                                <div
                                  className={`square-check-box ${
                                    airport?.zones?.length > 0 &&
                                    airport.zones.every(airportZone => selectedClient?.zones?.some(clientZone => clientZone.id === airportZone.id))
                                      ? 'checked'
                                      : ''
                                  }`}
                                  onClick={e => {
                                    e.stopPropagation();

                                    const airportZones = airport?.zones || [];

                                    const client = state?.client;
                                    const existingZones = client?.zones || [];

                                    // Check if all zones of this airport are already selected
                                    const isAlreadySelected = airportZones.every(airportZone =>
                                      existingZones.some(clientZone => clientZone.id === airportZone.id),
                                    );

                                    // Compute new zones
                                    let newZones = isAlreadySelected
                                      ? existingZones.filter(clientZone => !airportZones.some(az => az.id === clientZone.id))
                                      : [...existingZones, ...airportZones.filter(az => !existingZones.some(vz => vz.id === az.id))];

                                    newZones = newZones?.map(updatedZone => {
                                      return {
                                        id: updatedZone?.id,
                                        name: updatedZone?.name,
                                        airport: updatedZone?.airport,
                                      };
                                    });

                                    const updatedClient = {
                                      ...selectedClient,
                                      zones: newZones,
                                    };

                                    setSelectedClient(updatedClient);

                                    setState(prev => ({
                                      ...prev,
                                      client: updatedClient,
                                    }));
                                  }}
                                ></div>
                                <p className="m-0 fw-semibold fs-10">Select All</p>
                              </div>
                            </div>
                          </AccordionHeader>
                          <AccordionBody accordionId={airport.id}>
                            <Row>
                              {airport.zones.map((zone, index) => {
                                const isSelected = selectedClient?.zones?.find(
                                  clientZone => clientZone?.id === zone?.id && clientZone?.airport?.id === zone?.airport?.id,
                                );
                                return (
                                  <Col
                                    md={5}
                                    key={index}
                                    className="mb-2 border p-2 rounded mx-2 cursor-pointer"
                                    style={{ background: isSelected ? '#A1E5F7' : '' }}
                                    onClick={() => handleZoneToggle(zone)}
                                  >
                                    <div className="d-flex align-items-center gap-2">
                                      <img src={dots} alt="" />{' '}
                                      <p className="m-0 fw-medium" style={{ color: '#000000' }}>
                                        {zone?.name}
                                      </p>
                                    </div>
                                    <p className="mt-1 m-0">
                                      {zone?.distanceType} {zone?.distanceType !== 'Polygon' && ` - ${zone?.zoneRange?.to ?? 0} Km`}
                                    </p>
                                  </Col>
                                );
                              })}
                            </Row>
                          </AccordionBody>
                        </AccordionItem>
                      ))}
                    </UncontrolledAccordion>
                  </div>
                </div>
              </Col>

              <Col md="5">
                <div className="position-relative border border-radius-5 p-3">
                  <h5>Assigned Zones</h5>
                  <p className="text-muted small">Zones mapped to this client</p>
                  <div className="vendor-mapping-list">
                    <Card
                      className="mb-3 cursor-pointer p-2"
                      style={{
                        border: '1px dashed #D1D1D1',
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between cursor-pointer" onClick={() => setIsCollapse(!isCollapse)}>
                        <div className="d-flex flex-column pt-2 px-2">
                          <div className="d-flex gap-1 align-items-start">
                            <img className="mt-3" src={mapVendor} alt="" />
                            <div className="mt-2">
                              <div className="d-flex gap-2 align-items-center">
                                <h6 className="m-0 fw-medium fs-14">{selectedClient?.name || ''}</h6>
                                <p
                                  style={{
                                    color: '#0AB39C',
                                    border: '1px solid #0AB39C',
                                    borderRadius: '20px',
                                    fontSize: '6px',
                                  }}
                                  className="m-0 pt-1 pb-1 px-2 pe-2"
                                >
                                  Full Configured
                                </p>
                              </div>
                              <div className="d-flex gap-2 mt-1">
                                <p className="text-muted small m-0">{selectedClient?.contracting_country?.name ?? ''}</p>
                                <div className="d-flex flex-wrap gap-1">
                                  {selectedClient?.carTypes?.map((car, idx) => (
                                    <p
                                      key={idx}
                                      style={{
                                        borderRadius: '20px',
                                        padding: '5px 5px',
                                        fontSize: '8px',
                                        border: '1px solid #D0D2DC',
                                        color: '#6F7594',
                                      }}
                                      className="m-0"
                                    >
                                      {car?.name?.split(' ')[0]}
                                    </p>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>

                          <p className="mt-2 text-muted mb-0 fs-10 m-1" style={{ fontStyle: 'italic' }}>
                            Drop zones here
                          </p>
                        </div>

                        <div className="d-flex align-items-center gap-2">{isCollapse ? <ChevronDown size={18} /> : <ChevronRight size={18} />}</div>
                      </div>

                      <Collapse isOpen={isCollapse}>
                        {selectedClient?.zones?.map(zone => (
                          <div
                            key={zone?.id}
                            className="d-flex justify-content-between align-items-center p-2 m-1 rounded-2"
                            style={{ border: '1px solid #A1E5F7', background: '#A1E5F7' }}
                          >
                            <div
                              className="d-flex flex-column"
                              style={{
                                flex: 1,
                                minWidth: 0,
                              }}
                            >
                              <p className="fw-normal m-0 fs-12" style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                {zone?.name}
                              </p>
                              <p className="fw-light m-0 fs-12" style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                {zone?.airport?.name}
                              </p>
                            </div>
                            <p className="cursor-pointer fs-12 m-0" style={{ color: '#E60000' }} onClick={() => handleZoneRemove(zone.id)}>
                              Remove
                            </p>
                          </div>
                        ))}
                      </Collapse>
                    </Card>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <div className="d-flex justify-content-between">
          <Button
            onClick={() => setFormCount((prev: number) => prev - 1)}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC', // light gray
              color: '#404B7C', // navy/dark blue
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>
          <div className="d-flex gap-2">
            {isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '150px' }} color="primary" onClick={updateAsDraftHandler}>
                Update As Draft
              </Button>
            )}

            {!isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '130px' }} color="primary" onClick={saveAsDraftHandler}>
                Save As Draft
              </Button>
            )}

            <Button className="overlay-disable" style={{ width: '250px' }} color="primary" onClick={handleSubmit}>
              Proceed to Pricing
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AssignZonesToClient;
